import cnMessages from './cn.json';
import enMessages from './en.json';

import enLocale from 'element-ui/lib/locale/lang/en';
import cnLocale from 'element-ui/lib/locale/lang/zh-CN';

const cn = Object.assign(cnMessages, cnLocale);
const en = Object.assign(enMessages, enLocale);

export default {
    cn,
    en
};